String.prototype.replaceArray = function(find, replace) {
    var replaceString = this;
    var regex;
    for (var i = 0; i < find.length; i++) {
        var text = String(find[i]).trim().replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
        regex = new RegExp(text, "g");
        replaceString = replaceString.replace(regex, String(replace[i]).trim());
    }
    return replaceString;
};